/*** promo-video - Section Scripts ***/
(function () {
  const promoVideo = document.querySelector('[data-promotional-video]');
  const body = document.querySelector('body');

  if (promoVideo) {
    const modal = promoVideo.querySelector('[data-promotional-video-modal]');
    const modalVideo = modal.querySelector('video');

    const modalShow = function () {
      modal.classList.add('sticky-promotional-video__modal--show');
      if (window.pauseAllMedia) window.pauseAllMedia();
      document.body.style.overflow = 'hidden';

      window.setTimeout(function () {
        modalVideo.play();
      }, 500);
    };

    const modalHide = function () {
      modal.classList.remove('sticky-promotional-video__modal--show');
      console.log('PAUSE');
      modalVideo.pause();
      modalVideo.currentTime = 0;
      document.body.style.overflow = 'initial';
    };

    body.appendChild(modal);

    modal.addEventListener('click', (e) => {
      if (e.target !== modalVideo) {
        modalHide();
      }
    });

    promoVideo.addEventListener('click', (e) => {
      if (e.target.closest('[data-promotional-video-close]')) return;
      modalShow();
    });

    // PLAY ON LOAD
    if (promoVideo.paused) {
      promoVideo.play();
    }

    promoVideo.oncanplay = function () {
      promoVideo.play();
    };
  }
})();
